import { Flex, Layout, Typography, theme } from 'antd';
import { useGetMy } from 'api/users/use-get-my.ts';
import { ClearFavoriteButton } from 'components/favorites/clear-favorite-cargos';
import { Profile } from '../profile';
import styles from './header.module.scss';

const { Header: AntHeader } = Layout;

export const Header = () => {
  const {
    token: { colorBgContainer: color },
  } = theme.useToken();

  const { data: user } = useGetMy();

  return (
    <AntHeader className={styles.header} style={{ color }}>
      <Typography.Text style={{ fontSize: '1.5rem', color }} strong>
        Logist CRM
      </Typography.Text>
      <Flex gap={18} align='center'>
        <ClearFavoriteButton />
        <Profile userName={user?.name} />
      </Flex>
    </AntHeader>
  );
};
